module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Regular-90ee12c1c785a4c80226255c9c9692bf.woff2";